import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 3L17 17",
		stroke: "#333333",
		strokeWidth: 3,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17 3L3 17",
		stroke: "#333333",
		strokeWidth: 3,
		strokeLinecap: "square"
	})]
});
export default SvgClose;
